flattenFields